import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TrlPillStatusStyled } from './TrlTextPill.styles';

export const TrlTextPill = ({ value }) => {
  switch (value) {
    case 'N':
    case 'E':
      return (
        <TrlPillStatusStyled
          label={<FormattedMessage id="TRLT_UI-UNPROCESSED" />}
        />
      );
    case 'S':
      return (
        <TrlPillStatusStyled
          label={<FormattedMessage id="TRLT_UI-PROCESSED" />}
        />
      );
    default:
      return value;
  }
};

TrlTextPill.propTypes = {
  value: PropTypes.string,
};
